import React, { useContext } from 'react';
import { Doctors, SEO } from '../../components';
import { GlobalSiteDataContext } from '../../context';
import { graphql } from 'gatsby';
import './locations.css';

function AboutUsPage() {
  const siteData = useContext(GlobalSiteDataContext);
  return (
    <main id='about-us-page' className='pt-5'>
      <section className='pt-5 mt-5'></section>
      <Doctors siteData={siteData} hero={true} />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`About Us | Milan Laser Hair Removal | ${query.name}, ${query.stateAbbrev}`}
      description={`We provide state of the art laser hair removal treatments in a relaxing environment.`}
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default AboutUsPage;
